import React from "react";
import { useNavigate } from "react-router-dom";
import Profilepopup from "../Profilepopup";
import style from "./Navlinks.module.css";
import profile from "../../../Assets/profile.svg";
import edit from "../../../Assets/edit.svg";
import Logout from "../../../Assets/Logout.svg";
import Ajnavidyalogo from "../../../Assets/Ajnavidyalogo.svg";

import { authActions } from "../../../redux/actions";
import { useDispatch } from "react-redux";
import { recruiterNavlinks, studentNavlinks } from "./navlinksConstants";
import { CloseButton } from "@chakra-ui/react";
import { CheckOutsideClick } from "../Hamburger/CheckOutsideClick";

const Navlinks = ({ handle, type = "student", setChangeDisplay }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const navlinkfilter = (type) => {
    if (type === "recruiter") {
      return recruiterNavlinks;
    } else {
      return studentNavlinks;
    }
  };

  const close = () => {
    setChangeDisplay("none");
    handle();
  };

  return (
    <>
      <CheckOutsideClick onClickOutside={close}>
        <div className={style.mobileNavlinks}>
          <div className={style.logowithclosebtn}>
            <img src={Ajnavidyalogo} alt="Ajnavidyalogo" />
            <button onClick={() => close()} className={style.close}>
              <CloseButton />
            </button>
          </div>
          <div className={style.content}>
            {navlinkfilter(type)?.map((item, idx) => (
              <>
                <div
                  onClick={() =>
                    item?.isLogout
                      ? dispatch(authActions.logout())
                      : navigate(item.link)
                  }
                >
                  {item?.name}
                </div>
                {item?.break && <hr />}
              </>
            ))}
          </div>
        </div>
      </CheckOutsideClick>
    </>
  );
};

export default Navlinks;
